
import React from 'react';
import { Loader2, Hash, FileText, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Paper {
  id: string;
  title: string;
  needs_ai_review?: boolean;
  needs_keywords?: boolean;
  needs_research_info?: boolean;
}

interface RemediationActionsProps {
  paper: Paper;
  processingPapers: Set<string>;
  processingKeywords: Set<string>;
  processingResearchInfo: Set<string>;
  deletingPapers: Set<string>;
  onGenerateAIReview: (paper: Paper) => void;
  onGenerateKeywords: (paper: Paper) => void;
  onGenerateResearchInfo: (paper: Paper) => void;
  onDeletePaper: (paper: Paper) => void;
}

const RemediationActions: React.FC<RemediationActionsProps> = ({
  paper,
  processingPapers,
  processingKeywords,
  processingResearchInfo,
  deletingPapers,
  onGenerateAIReview,
  onGenerateKeywords,
  onGenerateResearchInfo,
  onDeletePaper
}) => {
  return (
    <div className="flex justify-end gap-2 flex-wrap">
      <Button
        size="sm"
        variant="outline"
        disabled={deletingPapers.has(paper.id)}
        onClick={() => onDeletePaper(paper)}
        className="text-destructive border-destructive/50 hover:bg-destructive/10"
      >
        {deletingPapers.has(paper.id) ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Trash2 className="h-4 w-4" />
        )}
      </Button>
      {paper.needs_keywords && (
        <Button
          size="sm"
          variant="outline"
          disabled={processingKeywords.has(paper.id)}
          onClick={() => onGenerateKeywords(paper)}
        >
          {processingKeywords.has(paper.id) ? (
            <>
              <Loader2 className="h-4 w-4 mr-1 animate-spin" />
              Generating...
            </>
          ) : (
            <>
              <Hash className="h-4 w-4 mr-1" />
              Generate Keywords
            </>
          )}
        </Button>
      )}
      {paper.needs_research_info && (
        <Button
          size="sm"
          variant="outline"
          disabled={processingResearchInfo.has(paper.id)}
          onClick={() => onGenerateResearchInfo(paper)}
        >
          {processingResearchInfo.has(paper.id) ? (
            <>
              <Loader2 className="h-4 w-4 mr-1 animate-spin" />
              Extracting...
            </>
          ) : (
            <>
              <FileText className="h-4 w-4 mr-1" />
              Extract Research Info
            </>
          )}
        </Button>
      )}
      {paper.needs_ai_review && (
        <Button
          size="sm"
          disabled={processingPapers.has(paper.id)}
          onClick={() => onGenerateAIReview(paper)}
        >
          {processingPapers.has(paper.id) ? (
            <>
              <Loader2 className="h-4 w-4 mr-1 animate-spin" />
              Processing...
            </>
          ) : (
            'Generate AI Review'
          )}
        </Button>
      )}
    </div>
  );
};

export default RemediationActions;
